import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { SecurityStats, FailedLoginSummary, UserSecurity } from '../types/security-admin'
import type { AuditLogEntry } from '../types/audit-log'

export async function getSecurityStats(): Promise<SecurityStats> {
  const response = await api.get<ApiResponse<SecurityStats>>('/api/admin/security/stats')
  return response.data.data
}

export async function getRecentLogins(limit: number = 20): Promise<AuditLogEntry[]> {
  const response = await api.get<ApiResponse<AuditLogEntry[]>>(`/api/admin/security/recent-logins?limit=${limit}`)
  return response.data.data
}

export async function getFailedLoginsSummary(): Promise<FailedLoginSummary[]> {
  const response = await api.get<ApiResponse<FailedLoginSummary[]>>('/api/admin/security/failed-logins-summary')
  return response.data.data
}

export async function getUsersMustChangePassword(): Promise<UserSecurity[]> {
  const response = await api.get<ApiResponse<UserSecurity[]>>('/api/admin/security/users-must-change-password')
  return response.data.data
}
